import React from 'react';
import { DEFAULT_404_PHOTO, IMAGE_HEIGHT, IMAGE_WIDTH } from './constant';

const PcMainImageEmpty = () => {
  return (
    <div
      className="pc-main-image__empty"
      style={{
        width: IMAGE_WIDTH,
        height: IMAGE_HEIGHT,
      }}
    >
      <img
        src={DEFAULT_404_PHOTO}
        alt="404"
        style={{
          width: 250,
          height: 250,
        }}
      />
    </div>
  );
};

export default PcMainImageEmpty;
